import copyCustomMetricsToPageTimings from 'mini-performance/lib/utils/copyCustomMetricsToPageTimings';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import initializeErrorHandlerDevtools from './utils/initializeErrorHandlerDevtools';
import initializeNotifications from './initializeNotifications';
import logDatapointsAfterInitialRender from './utils/logDatapointsAfterInitialRender';
import { addVisibilityEventListener } from './utils/addVisibilityEventListener';
import { dynamicModeChange } from 'mini-theme/lib/utils/dynamicModeChange';
import { executeDiagnosticsTask } from 'mini-diagnostics/lib/utils/executeDiagnosticsTask';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { isRoamingSignatureEnabled } from 'mini-mail-compose-store/lib/utils/signatureUtils';
import { lazybootStrapWebPushService } from 'mini-webpush-notifications';
import { lazyGetMailModuleDiagnosticsStore } from 'mini-mail-diagnostics-store';
import { lazyInitializeMiniOptinService } from 'mini-optin';
import { lazyInitializeRollupStore } from 'mini-mail-focused-inbox-rollup-store';
import { lazyInitializeServiceWorker } from 'mini-serviceworker';
import { lazyLoadEmailSignaturePreferences } from 'mini-mail-signature';
import { lazyLoadLightningPrimaryView } from 'mini-mail-lightning-view';
import { lazyLoadSignatureInUserOptions } from 'mini-options-message-options';
import { lazyPrefetchForFastModuleSwitch } from 'mini-fast-moduleswitch';
import { lazyValidateCache } from 'owa-boot-cache';
import { loadCLPUserLabels } from './loadCLPUserLabels';
import { logUserFastBootSettingsChanges } from 'mini-early-processing/lib/userFastBootSettingsUtils';
import { sendLastUrlToExtension } from 'extension-communication';
import { stampFeatureFlags } from 'owa-mini-feature-flags/lib/stampFeatureFlags';
import { subscribeToHierarchyNotification } from 'mini-mail-folder-store';
import { SWAppName } from 'data/lib/mini-app-constants';
import { triggerLazyInitializeCampaignFrameworkForMail } from './utils/triggerInitializeCampaignFrameworkForMail';
const checkSupportAndBootstrapWebPushService = () => {
    /*const isWebPushSupported = isWebPushNotificationSupported(window);
    // tslint:disable-next-line:no-console
    console.log('isWebPushSupported: ', isWebPushSupported);
    if (isWebPushSupported) {*/
    lazybootStrapWebPushService.importAndExecute(window);
    /*}*/
};

export type BootstrapOneTimeSetupInitializeConfig = {
    campaigns: boolean;
    sw: boolean;
};
export const defaultBootstrapOneTimeSetupInitializeConfig = {
    campaigns: false,
    sw: true,
};
/**
 * Mail specific code to execute after shared bootstrap promise
 */
export const postMailBootstrapOneTimeSetup = ({
    sw,
}: BootstrapOneTimeSetupInitializeConfig = defaultBootstrapOneTimeSetupInitializeConfig): void => {
    // enable dev-tools
    executeDiagnosticsTask(lazyGetMailModuleDiagnosticsStore.importAndExecute, true);
    loadCLPUserLabels();
    if (!isRoamingSignatureEnabled()) {
        // Load message options
        lazyLoadSignatureInUserOptions.importAndExecute();
    }

    // Initialize data from SDS into local store
    lazyLoadEmailSignaturePreferences.importAndExecute();

    lazyInitializeRollupStore.import().then(initializeRollupStore => {
        initializeRollupStore(FocusedViewFilter.Other);
    });

    checkSupportAndBootstrapWebPushService();
    triggerLazyInitializeCampaignFrameworkForMail();
    lazyLoadLightningPrimaryView.importAndExecute();

    lazyInitializeMiniOptinService.importAndExecute();
    lazyValidateCache.importAndExecute();

    subscribeToHierarchyNotification();

    initializeNotifications();
    if (sw) {
        lazyInitializeServiceWorker.import().then(initializeServiceWorker => {
            initializeServiceWorker(window, SWAppName.miniEdge);
        });
    }
    stampFeatureFlags();
    initializeErrorHandlerDevtools();
    logDatapointsAfterInitialRender();
    copyCustomMetricsToPageTimings();
    dynamicModeChange();
    addVisibilityEventListener();

    lazyPrefetchForFastModuleSwitch.importAndExecute();
    logUserFastBootSettingsChanges();
    sendLastUrlToExtension(getHostLocation().href);
};

export const postMailBootstrap = (): void => {
    // Perform operations those need to be done both for initial bootstrap with stale data and rebootstrap with server data
    // tslint:disable-next-line: no-console
    console.log('This runs after initial bootstrap and rebootstrap both');
};
